/**
 * @generated SignedSource<<a63742324ad09ca3be76d7e985d0483a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEstimateSimilarSoldRange_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item" | "useGetEstimatedValueRange_item" | "useShowPricingGuidance_item">;
  readonly " $fragmentType": "PdpSharedEstimateSimilarSoldRange_item";
};
export type PdpSharedEstimateSimilarSoldRange_item$key = {
  readonly " $data"?: PdpSharedEstimateSimilarSoldRange_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimateSimilarSoldRange_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEstimateSimilarSoldRange_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetEstimatedValueRange_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "505e5fe9062b1661ac81ad606b11f2f2";

export default node;
